module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GUARDIAN_OF_CROWN_STYLE.f03cfa25.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GUARDIAN_OF_CROWN_STYLE.png
// module id = 1161
// module chunks = 16